import React, { useEffect, useState } from 'react'
import AppSelect from 'components/atoms/AppSelect/AppSelect'
import SelectChute from '../PatternSelectChute/PatternSelectChute'
import { Chute } from 'interfaces/templates'

interface Props {
    chutes: Chute[]
    ruleOptions: { value: string; label: string }[]
    onDelete: () => void
    onChutesSelected: (ruleIndex: number, selected: number[]) => void
    selectedChutes: number[]
    ruleIndex: number
    onGroupUpdate: (
        ruleIndex: number,
        group_id: number,
        chutes: number[]
    ) => void
    selectedRuleId?: string
    defaultChutes?: { chute: number; id: number }[]
    disabledRuleIds?: number[]
}

interface ChuteList {
    chute: number
    type: string
    id?: number
}

const PatternFormRuleItem = ({
    chutes,
    ruleOptions,
    onChutesSelected,
    selectedChutes,
    ruleIndex,
    onGroupUpdate,
    selectedRuleId,
    defaultChutes,
    disabledRuleIds = [],
}: Props) => {
    const [showChutes, setShowChutes] = useState(false)
    const [chutesList, setChutesList] = useState<ChuteList[]>([])
    const [selectedRule, setSelectedRule] = useState<string>(
        selectedRuleId || ''
    )

    useEffect(() => {
        if (
            defaultChutes?.length &&
            selectedRuleId &&
            chutesList.length === 0
        ) {
            const formatted = defaultChutes.map((ch) => ({
                chute: ch.chute,
                type: 'selected',
                id: ch.id,
            }))

            setChutesList(formatted)
            onChutesSelected(
                ruleIndex,
                defaultChutes.map((ch) => ch.chute)
            )
            onGroupUpdate(
                ruleIndex,
                Number(selectedRuleId),
                defaultChutes.map((ch) => ch.id)
            )
        }
    }, [defaultChutes, selectedRuleId])

    const handleChutesChange = (selected: Chute[]) => {
        const formatted = selected.map((item) => ({
            chute: item.chute,
            type: 'selected',
            id: item.id,
        }))

        setChutesList(formatted)
        onChutesSelected(
            ruleIndex,
            selected.map((item) => item.chute)
        )
        setShowChutes(false)

        const group_id = Number(selectedRule)
        const chuteIds = selected
            .map((item) => item.id)
            .filter((id): id is number => id !== undefined)
        onGroupUpdate(ruleIndex, group_id, chuteIds)
    }

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newRule = event.target.value
        setSelectedRule(newRule)
        setChutesList([])
        onChutesSelected(ruleIndex, [])
        onGroupUpdate(ruleIndex, Number(newRule), [])
    }

    const computedRuleOptions = ruleOptions.map((o) => {
        const valStr = String(o.value)
        const valNum = Number(o.value)
        const isInUse = disabledRuleIds.includes(valNum)
        const currentSelected = selectedRule !== '' && valStr === selectedRule
        return {
            ...o,
            disabled: isInUse && !currentSelected,
        }
    })

    return (
        <div className="w-full flex items-start">
            <div className="w-96 p-4">
                <AppSelect
                    label="Regla"
                    placeholder="Seleccionar"
                    value={selectedRule}
                    onChange={handleChange}
                    options={computedRuleOptions}
                />
            </div>
            <div className="mt-4 flex flex-col items-start w-full">
                {/*<p className="mb-1">Chut</p>
                <div className="flex w-full items-center justify-between">
                    <div className="flex gap-[6px]">
                        {chutesList.length > 0 ? (
                            <>
                                {chutesList.map((val) => (
                                    <div
                                        key={val.id ?? val.chute}
                                        className="rounded-md flex justify-center items-center w-[40px] h-[40px] bg-[#F1F9EC] cursor-not-allowed"
                                    >
                                        {val.chute}
                                    </div>
                                ))}
                                <div
                                    onClick={() =>
                                        canOpenSelector && setShowChutes(true)
                                    }
                                    className={`border rounded-md flex justify-center items-center w-[40px] h-[40px] transition-all duration-300
                    ${
                        canOpenSelector
                            ? 'cursor-pointer hover:bg-[#E2E8F0]'
                            : 'cursor-not-allowed bg-gray-100'
                    }`}
                                >
                                    <img src={IconPencil} alt="Edit" />
                                </div>
                            </>
                        ) : (
                            <div
                                onClick={() =>
                                    canOpenSelector && setShowChutes(true)
                                }
                                className={`border rounded-md flex justify-center items-center w-[40px] h-[40px] transition-all duration-300
                  ${
                      canOpenSelector
                          ? 'cursor-pointer hover:bg-[#E2E8F0]'
                          : 'cursor-not-allowed bg-gray-100'
                  }`}
                            >
                                <img src={IconAdd} alt="Add" />
                            </div>
                        )}
                    </div>

                    <div
                        onClick={onDelete}
                        className="border rounded-md flex justify-center items-center w-[40px] h-[40px] cursor-pointer hover:bg-[#E2E8F0] transition-all duration-300"
                    >
                        <img src={IconTrash} alt="Delete" />
                    </div>
                </div>
                */}
            </div>

            {showChutes && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                    <div className="relative">
                        <SelectChute
                            chutes={chutes}
                            onChange={handleChutesChange}
                            onClose={() => setShowChutes(false)}
                            disabledChutes={selectedChutes}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

PatternFormRuleItem.displayName = 'PatternForm.RuleItem'
export default PatternFormRuleItem
